/* Ximena Robledo - ficha de producto: guía de tallas, etiquetas, valoración, stock bajo */
(function () {
  'use strict';
  function fixLegends() {
    document.querySelectorAll('variant-picker legend').forEach(function (lg) {
      var n = lg.firstChild;
      if (!n || n.nodeType !== 3) return;
      var raw = n.textContent.trim().replace(/:$/, '');
      if (!raw) return;
      var want = lg.querySelector('.variant-option__swatch-value') ? raw + ':' : raw;
      if (n.textContent !== want) n.textContent = want;
    });
  }
  function lowStock() {
    var el = document.querySelector('[data-xr-low]');
    if (!el) return;
    var ids = (el.getAttribute('data-xr-low') || '').split(',').filter(Boolean);
    var js = document.querySelector('variant-picker script[type="application/json"]');
    var id = null;
    try { id = js ? String(JSON.parse(js.textContent).id) : null; } catch (e) {}
    if (!id) { var m = location.search.match(/variant=(\d+)/); id = m ? m[1] : null; }
    var show = id && ids.indexOf(id) > -1;
    if (el.hidden === !!show) el.hidden = !show;
  }
  function placeLink() {
    fixLegends();
    lowStock();
    if (!document.getElementById('xr-size-guide')) return;
    var legends = document.querySelectorAll('variant-picker fieldset legend, variant-picker .variant-option--dropdowns > label');
    var target = null;
    legends.forEach(function (l) {
      if (!target && /^\s*(talla|size|tama|taglia)/i.test(l.textContent)) target = l;
    });
    if (!target) return;
    if (!target.querySelector('.xr-sg-inline')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'xr-sg-inline';
      b.setAttribute('data-xr-open', 'xr-size-guide');
      b.setAttribute('aria-haspopup', 'dialog');
      b.textContent = 'Guía de tallas';
      target.classList.add('xr-legend-sg');
      target.appendChild(b);
    }
    document.documentElement.classList.add('xr-sg-inline-on');
  }
  function buildRating() {
    if (document.querySelector('[data-xr-move="title"]')) return;
    var s = document.getElementById('xr-resenas');
    if (!s) return;
    var avg10 = parseInt(s.getAttribute('data-xr-rv-avg10'), 10) || 0;
    var total = parseInt(s.getAttribute('data-xr-rv-total'), 10) || 0;
    if (!total) return;
    var label = s.getAttribute('data-xr-rv-label') || '';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'xr-prate';
    b.setAttribute('data-xr-move', 'title');
    b.setAttribute('data-xr-goto', '#xr-resenas');
    b.setAttribute('aria-label', 'Ver opiniones de clientas');
    b.innerHTML = '<span class="xr-rv__stars" style="--xr-rv:' + (avg10 * 2) + '%"></span><b></b><span class="xr-prate__sep">·</span><span>' + Math.floor(avg10 / 10) + ',' + (avg10 % 10) + '/5</span><span class="xr-prate__sep">·</span><span>' + total + (total === 1 ? ' calificación' : ' calificaciones') + '</span>';
    b.querySelector('b').textContent = label;
    document.body.appendChild(b);
  }
  function moveBits() {
    var root = document.querySelector('.product-details') || document;
    var rate = document.querySelector('[data-xr-move="title"]');
    var h1 = root.querySelector('h1');
    if (rate && h1 && !rate.dataset.moved) {
      var tblock = h1.closest('.text-block') || h1;
      tblock.parentNode.insertBefore(rate, tblock);
      rate.dataset.moved = '1';
    }
    var lines = document.querySelector('[data-xr-move="price"]');
    var price = root.querySelector('product-price');
    if (lines && price && !lines.dataset.moved) {
      price.parentNode.insertBefore(lines, price.nextSibling);
      lines.dataset.moved = '1';
    }
  }
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-xr-goto]');
    if (g) {
      var t = document.querySelector(g.getAttribute('data-xr-goto'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  }, true);
  function start() {
    var st = document.createElement('style'); st.textContent = '.xr-legend-sg{display:flex!important;width:100%;align-items:baseline;justify-content:space-between;gap:12px}.xr-sg-inline{margin-left:auto;background:none;border:0;padding:0;font-family:var(--xr-sans);font-size:12px;font-weight:400;letter-spacing:.04em;text-transform:none!important;text-decoration:underline;text-underline-offset:3px;color:var(--xr-ink);cursor:pointer}.xr-sg-inline-on [data-xr-sg-btn]{display:none!important}'; document.head.appendChild(st);
    buildRating();
    moveBits();
    placeLink();
    var mo = new MutationObserver(function () { placeLink(); });
    document.querySelectorAll('variant-picker').forEach(function (vp) {
      mo.observe(vp.parentNode || vp, { childList: true, subtree: true, characterData: true });
    });
    document.addEventListener('change', function () { setTimeout(placeLink, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
